import { debounce } from '@/utils/debounce';

export function createDimensions () {
    let tickScroll = true;
    let tickResize = true;

    return {
        namespaced: true,
        state: {
            mode: 'l',
            top: 0,
            width: 0,
            height: 0,
            windowHeight: 0,
            topBorder: 0,
            maxVisibleHeight: 0,
            flowElement: null,
            chatHeaderHeight: 0,
        },
        getters: {
            widgetMinHeight (state) {
                return Math.min(state.maxVisibleHeight, window.innerHeight, state.height);
            },
        },
        mutations: {
            SET_CHAT_HEADER_HEIGHT (state, height) {
                state.chatHeaderHeight = height;
            },
            SET_WIDGET_HEIGHT (state, rootNode) {
                let eFlow = rootNode.querySelector('[data-odr-flow]');
                if (eFlow) {
                    state.height = eFlow.offsetHeight;
                }
            },
            SET_TICK_RESIZE (state, tick) {
                tickResize = tick;
            },
            SET_TICK_SCROLL (state, tick) {
                tickScroll = tick;
            },
            SET_FLOW_ELEMENT (state, element) {
                state.flowElement = element;
            },
            SET_RESIZE (state, { appConfig }) {
                state.windowHeight = window.innerHeight;
                state.top = appConfig.mode === 'chat' ? state.flowElement.scrollTop : window.pageYOffset;
                state.height = state.flowElement.offsetHeight;
                state.topBorder = state.flowElement.getBoundingClientRect().top;

                state.width = parseInt(state.flowElement.offsetWidth, 10);
                if (appConfig.stepsCenteredHorizontal && appConfig.mode === 'normal' && state.width > appConfig.stepsCenteredWidth) {
                    state.width = appConfig.stepsCenteredWidth;
                }

                if (state.width > 750) {
                    state.mode = 'l';
                } else if (state.width > 420) {
                    state.mode = 'm';
                } else if (state.width > 320) {
                    state.mode = 's';
                } else {
                    state.mode = 'xs';
                }
            },
            SET_SCROLL (state, { appConfig }) {
                state.top = appConfig.mode === 'chat' ? state.flowElement.scrollTop : window.pageYOffset;
                state.topBorder = state.flowElement.getBoundingClientRect().top;
            },
            SET_DEBOUNCED_SCROLL (state) {
                state.windowHeight = window.innerHeight;
                state.height = state.flowElement.offsetHeight;
                state.maxVisibleHeight = state.windowHeight - state.flowElement.getBoundingClientRect().y;
            },
        },
        actions: {
            SET_DIMENSIONS_RESIZE ({ commit }, { appConfig }) {
                if (!tickResize) {
                    return;
                }
                tickResize = false;
                window.requestAnimationFrame(() => {
                    commit('SET_RESIZE', { appConfig });
                    tickResize = true;
                });
            },
            SET_DIMENSIONS_SCROLL ({ commit }, { appConfig }) {
                if (!tickScroll) {
                    return;
                }
                tickScroll = false;
                window.requestAnimationFrame(() => {
                    commit('SET_SCROLL', { appConfig });
                    debounce(() => {
                        commit('SET_DEBOUNCED_SCROLL');
                    }, 200, true);

                    tickScroll = true;
                });
            },
        },
    };
}
